module.exports = __webpack_public_path__ + "img/repair_banner2.png";